const resolveWebAppOrigin = (): string => {
  const { protocol, hostname } = window.location;

  if (hostname === "localhost") {
    return `${protocol}//${hostname}:4200`;
  }

  if (hostname.startsWith("auth-")) {
    return `${protocol}//${hostname.replace(/^auth-/, "")}`;
  }

  if (hostname === "auth.lumana.ai") {
    return `${protocol}//app.lumana.ai`;
  }

  return `${protocol}//${hostname}`;
};

const buildLogoutUrl = (): string => {
  const logoutUrl = new URL("/v2/logout", window.location.origin);
  const clientId = window.universal_login_context?.client?.id;
  const returnTo = new URL("/", resolveWebAppOrigin());

  if (clientId) {
    logoutUrl.searchParams.set("client_id", clientId);
  }

  logoutUrl.searchParams.set("returnTo", returnTo.toString());

  return logoutUrl.toString();
};

export const logoutToAuthorize = (): void => {
  window.location.assign(buildLogoutUrl());
};

export const logoutToFreshLogin = (): void => {
  window.location.assign(buildLogoutUrl());
};
